module.exports = __webpack_public_path__ + "img/network.a34cc406.svg";